<template>
  <div class="identity-awaiting">
    <substrate-mount>
      <p v-html="$t('we.need.a.little.processing.time')"></p>
    </substrate-mount>
  </div>
</template>

<script>
import SubstrateMount from '@/components/capusta/SubstrateMount';

export default {
  components: {
    SubstrateMount,
  },
};
</script>

<style lang="sass" scoped>
  .identity-awaiting
    position: relative
    z-index: -1

  p
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    &::v-deep span
      display: block
</style>
